 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import WINGEDVICTORY_FRONTCOVER from '@/components/WingedVictory_frontcover'
 import WINGEDVICTORY_TITLE from '@/components/WingedVictory_title'
 import WINGEDVICTORY_COPYRIGHT from '@/components/WingedVictory_copyright'
 import WINGEDVICTORY_DEDICATION from '@/components/WingedVictory_dedication'
 import WINGEDVICTORY_TOC from '@/components/WingedVictory_toc'
 import WINGEDVICTORY_PHASE1 from '@/components/WingedVictory_phase1'
 import WINGEDVICTORY_PHASE101 from '@/components/WingedVictory_phase101'
 import WINGEDVICTORY_PHASE102 from '@/components/WingedVictory_phase102'
 import WINGEDVICTORY_PHASE103 from '@/components/WingedVictory_phase103'
 import WINGEDVICTORY_PHASE104 from '@/components/WingedVictory_phase104'
 import WINGEDVICTORY_PHASE105 from '@/components/WingedVictory_phase105'
 import WINGEDVICTORY_PHASE106 from '@/components/WingedVictory_phase106'
 import WINGEDVICTORY_PHASE107 from '@/components/WingedVictory_phase107'
 import WINGEDVICTORY_PHASE108 from '@/components/WingedVictory_phase108'
 import WINGEDVICTORY_PHASE109 from '@/components/WingedVictory_phase109'
 import WINGEDVICTORY_PHASE110 from '@/components/WingedVictory_phase110'
 import WINGEDVICTORY_PHASE111 from '@/components/WingedVictory_phase111'
 import WINGEDVICTORY_PHASE112 from '@/components/WingedVictory_phase112'
 import WINGEDVICTORY_PHASE113 from '@/components/WingedVictory_phase113'
 import WINGEDVICTORY_PHASE114 from '@/components/WingedVictory_phase114'
 import WINGEDVICTORY_PHASE115 from '@/components/WingedVictory_phase115'
 import WINGEDVICTORY_PHASE116 from '@/components/WingedVictory_phase116'
 import WINGEDVICTORY_PHASE117 from '@/components/WingedVictory_phase117'
 import WINGEDVICTORY_PHASE118 from '@/components/WingedVictory_phase118'
 import WINGEDVICTORY_PHASE119 from '@/components/WingedVictory_phase119'
 import WINGEDVICTORY_PHASE120 from '@/components/WingedVictory_phase120'
 import WINGEDVICTORY_PHASE121 from '@/components/WingedVictory_phase121'
 import WINGEDVICTORY_PHASE122 from '@/components/WingedVictory_phase122'
 import WINGEDVICTORY_PHASE123 from '@/components/WingedVictory_phase123'
 import WINGEDVICTORY_PHASE124 from '@/components/WingedVictory_phase124'
 import WINGEDVICTORY_PHASE2 from '@/components/WingedVictory_phase2'
 import WINGEDVICTORY_PHASE201 from '@/components/WingedVictory_phase201'
 import WINGEDVICTORY_PHASE202 from '@/components/WingedVictory_phase202'
 import WINGEDVICTORY_PHASE203 from '@/components/WingedVictory_phase203'
 import WINGEDVICTORY_PHASE204 from '@/components/WingedVictory_phase204'
 import WINGEDVICTORY_PHASE205 from '@/components/WingedVictory_phase205'
 import WINGEDVICTORY_PHASE206 from '@/components/WingedVictory_phase206'
 import WINGEDVICTORY_PHASE207 from '@/components/WingedVictory_phase207'
 import WINGEDVICTORY_PHASE208 from '@/components/WingedVictory_phase208'
 import WINGEDVICTORY_PHASE209 from '@/components/WingedVictory_phase209'
 import WINGEDVICTORY_PHASE210 from '@/components/WingedVictory_phase210'
 import WINGEDVICTORY_PHASE211 from '@/components/WingedVictory_phase211'
 import WINGEDVICTORY_PHASE212 from '@/components/WingedVictory_phase212'
 import WINGEDVICTORY_PHASE213 from '@/components/WingedVictory_phase213'
 import WINGEDVICTORY_PHASE3 from '@/components/WingedVictory_phase3'
 import WINGEDVICTORY_PHASE301 from '@/components/WingedVictory_phase301'
 import WINGEDVICTORY_PHASE302 from '@/components/WingedVictory_phase302'
 import WINGEDVICTORY_PHASE303 from '@/components/WingedVictory_phase303'
 import WINGEDVICTORY_PHASE304 from '@/components/WingedVictory_phase304'
 import WINGEDVICTORY_PHASE305 from '@/components/WingedVictory_phase305'
 import WINGEDVICTORY_PHASE306 from '@/components/WingedVictory_phase306'
 import WINGEDVICTORY_PHASE307 from '@/components/WingedVictory_phase307'
 import WINGEDVICTORY_PHASE308 from '@/components/WingedVictory_phase308'
 import WINGEDVICTORY_PHASE309 from '@/components/WingedVictory_phase309'
 import WINGEDVICTORY_PHASE310 from '@/components/WingedVictory_phase310'
 import WINGEDVICTORY_PHASE311 from '@/components/WingedVictory_phase311'
 import WINGEDVICTORY_PHASE312 from '@/components/WingedVictory_phase312'
 import WINGEDVICTORY_PHASE313 from '@/components/WingedVictory_phase313'
 import WINGEDVICTORY_PHASE314 from '@/components/WingedVictory_phase314'
 import WINGEDVICTORY_PHASE315 from '@/components/WingedVictory_phase315'
 import WINGEDVICTORY_PHASE316 from '@/components/WingedVictory_phase316'
 import WINGEDVICTORY_PHASE317 from '@/components/WingedVictory_phase317'
 import WINGEDVICTORY_PHASE318 from '@/components/WingedVictory_phase318'
 import WINGEDVICTORY_PHASE319 from '@/components/WingedVictory_phase319'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/WingedVictory_frontcover",
 			"name" : "WingedVictory_frontcover",
 			"component" : WINGEDVICTORY_FRONTCOVER
 		},
 		{
 			"path" : "/WingedVictory_title",
 			"name" : "WingedVictory_title",
 			"component" : WINGEDVICTORY_TITLE
 		},
 		{
 			"path" : "/WingedVictory_copyright",
 			"name" : "WingedVictory_copyright",
 			"component" : WINGEDVICTORY_COPYRIGHT
 		},
 		{
 			"path" : "/WingedVictory_dedication",
 			"name" : "WingedVictory_dedication",
 			"component" : WINGEDVICTORY_DEDICATION
 		},
 		{
 			"path" : "/WingedVictory_toc",
 			"name" : "WingedVictory_toc",
 			"component" : WINGEDVICTORY_TOC
 		},
 		{
 			"path" : "/WingedVictory_phase1",
 			"name" : "WingedVictory_phase1",
 			"component" : WINGEDVICTORY_PHASE1
 		},
 		{
 			"path" : "/WingedVictory_phase101",
 			"name" : "WingedVictory_phase101",
 			"component" : WINGEDVICTORY_PHASE101
 		},
 		{
 			"path" : "/WingedVictory_phase102",
 			"name" : "WingedVictory_phase102",
 			"component" : WINGEDVICTORY_PHASE102
 		},
 		{
 			"path" : "/WingedVictory_phase103",
 			"name" : "WingedVictory_phase103",
 			"component" : WINGEDVICTORY_PHASE103
 		},
 		{
 			"path" : "/WingedVictory_phase104",
 			"name" : "WingedVictory_phase104",
 			"component" : WINGEDVICTORY_PHASE104
 		},
 		{
 			"path" : "/WingedVictory_phase105",
 			"name" : "WingedVictory_phase105",
 			"component" : WINGEDVICTORY_PHASE105
 		},
 		{
 			"path" : "/WingedVictory_phase106",
 			"name" : "WingedVictory_phase106",
 			"component" : WINGEDVICTORY_PHASE106
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js